// @flow

export const ACCEPT_SOD_TNC = 'ACCEPT_SOD_TNC';
export const GET_SOD_TNC = 'GET_SOD_TNC';

const settandcCookie = (key, value) => ({
  type: ACCEPT_SOD_TNC,
  key,
  value,
});

export const updateTermsAndConditionsState = () => ({
  type: GET_SOD_TNC,
});

export const defaultState = {
  sodtncAccepted: false,
};

export const acceptsodTnC = () => (dispatch) => {
  dispatch(settandcCookie(ACCEPT_SOD_TNC, true));
};

const tancReducer = (
  state: Object = defaultState,
  action: Object = {},
) => {
  const profileId = localStorage.getItem('profileId');
  const tncKey = `ACCEPTED-TERMS-${profileId}`;
  const theseCookies = document.cookie.split(';').reduce((ac, cv) => Object.assign(ac, { [cv.split('=')[0].trim()]: cv.split('=')[1] }), {});
  const acceptedTC = theseCookies[tncKey] === 'true';
  const expireswhen = 'expires=31 Dec 9999 23:59:59 UTC';
  switch (action.type) {
    case ACCEPT_SOD_TNC:
      document.cookie = `${tncKey}=${action.value}; ${expireswhen}`;
      return Object.assign({}, {
        sodtncAccepted: action.value,
      });
    case GET_SOD_TNC:
      return Object.assign({}, {
        sodtncAccepted: acceptedTC,
      });
    default:
      return state;
  }
};

export default tancReducer;
